<template >
    <div>

        <div class="text-center ">
            <v-dialog v-model="dialog" width="1100" dark attach="#app" @click:outside="$emit('update-dialog', !dialog)">
                <v-dialog v-model="Reqdialog" dark persistent max-width="400">
                    <v-card class="!bg-black pb-2 !border-0 !rounded-tr-2xl !rounded-bl-2xl ">
                        <v-btn icon right class="!right-0 !absolute" @click="Reqdialog = false">
                            <v-icon>mdi-close-circle-outline</v-icon>
                        </v-btn>
                        <v-card-title class="text-xl !break-normal text-center !block !font-Handel"
                            :class="`${routeLink}_fortext`">
                            Please select your
                            <v-tooltip top dark color="black">
                                <template v-slot:activator="{ on, attrs }">
                                    <span class="font-weight-bold" v-bind="attrs" v-on="on"> date </span>
                                </template>
                                <span :class="`${routeLink}_fortext`">The term(Dutch) stems from restaurant dining
                                    etiquette in the
                                    Western
                                    world, where each person pays for their meal.</span>
                            </v-tooltip>
                            type
                        </v-card-title>
                        <v-row justify="space-around" align="center" no-gutters>
                            <v-btn class="white--text font-Handel" :loading="standardLoad" small text
                                @click="sendRequest('Standard')">
                                Standard
                            </v-btn>
                            <v-btn class="font-Handel white--text" small text @click="sendRequest('Dutch')">
                                Dutch
                            </v-btn>
                        </v-row>
                    </v-card>
                </v-dialog>
                <v-card class="!bg-black !border-0 !rounded-tl-3xl !rounded-br-3xl">
                    <div class="flex items-center py-5 sm:!px-10 !px-5 ">
                        <Icon icon="teenyicons:user-circle-outline" class="!text-4xl" :color="colorAsRoute" />
                        <v-card-title :class="`${routeLink}_fortext !text-3xl !font-semibold capitalize`">{{
                            userData.name
                        }}
                            Profile</v-card-title>
                        <v-spacer></v-spacer>
                        <v-btn icon :color="colorAsRoute" text @click="$emit('update-dialog', !dialog)">
                            <Icon icon="material-symbols:cancel-outline" class="sm!text-4xl !text-3xl" />
                        </v-btn>
                    </div>
                    <div :class="`border-b-[1px]  ${routeLink}-border`"></div>
                    <div class="sm:p-10 p-5 pt-0 mt-10  overflow-auto h-full">
                        <div class=" flex items-center sm:flex-row flex-col sm:gap-0 gap-3">
                            <v-avatar rounded="xl" height="380px" width="280" :class="`!border-2 ${routeLink}-border`">
                                <v-img :src="userData.image" />
                            </v-avatar>
                            <div class="font-semibold font-Inter px-5">
                                <div class="text-2xl text-gray-400">Bio</div>
                                <div :class="`${routeLink}_fortext   text-4xl font-bold capitalize`">{{ userData.name }}
                                </div>
                                <v-list dense color="transparent" class="for_icon">
                                    <v-list-item class="text-white pa-0">
                                        <v-list-item-icon>
                                            <!-- <v-icon :color="colorAsRoute">mdi-book-education</v-icon> -->
                                            <Icon icon="emojione-monotone:school" class="!text-3xl" :color="colorAsRoute" />
                                        </v-list-item-icon>
                                        <v-list-item-content>
                                            <v-list-item-title class="!text-lg font-Inter font-semibold !capitalize pt-1">{{
                                                userData.education ?
                                                userData.education :
                                                "Education Not Available"
                                            }}
                                            </v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-list-item class="text-white pa-0">
                                        <v-list-item-icon>
                                            <Icon icon="bi:calendar2-heart" class="!text-3xl" :color="colorAsRoute" />
                                        </v-list-item-icon>
                                        <v-list-item-content>
                                            <v-list-item-title class="!text-lg font-Inter font-semibold !capitalize">{{
                                                userData.partner_age_range ?
                                                userData.partner_age_range :
                                                'Partners Age Range Not Available'

                                            }}
                                            </v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-list-item class="text-white pa-0">
                                        <v-list-item-icon>
                                            <Icon icon="ph:briefcase" class="!text-4xl" :color="colorAsRoute" />
                                        </v-list-item-icon>
                                        <v-list-item-content>
                                            <v-list-item-title class="!text-lg font-Inter font-semibold !capitalize">{{
                                                userData.job ?
                                                userData.job :
                                                'job Not Available'

                                            }}</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                                <h3 class="text-xl my-2">
                                    <span class="text-gray-400">Hobbies</span>
                                </h3>

                                <div class="hobbies flex gap-3 flex-wrap">
                                    <v-list-item-title v-if="userData.user_intrests && !userData.user_intrests.length > 0"
                                        class="!text-lg  !capitalize bg-black !text-center rounded-lg py-3 border-[1px] border-gray-500">
                                        Hobbies Not Available
                                    </v-list-item-title>
                                    <v-chip
                                        :class="` hover:scale-110 !duration-500 font-Inter !transition-transform text-black for_spinner ${routeLink}_color`"
                                        :color="`${routeLink}` == 'straight' ? '#cba440' : `${routeLink}` == 'gay' ? '#78a8f4' : `${routeLink}` == 'lesbian' ? '#a032f5' : ''"
                                        v-for="item in userData.user_intrests" :key="item.key">

                                        {{ item.interest.title }}
                                    </v-chip>
                                </div>
                            </div>
                        </div>
                        <div class="py-10 sm:px-0 px-5">
                            <div class="text-3xl font-Inter font-semibold  text-gray-400">About</div>
                            <v-list-item-title v-if="!userData.about"
                                class="!text-lg  !capitalize bg-black !text-center rounded-lg py-3 border-[1px] my-2 border-gray-500">
                                About Not Available
                            </v-list-item-title>
                            <div class=" sm:w-3/4 mt-4 text-gray-300" v-else>{{ userData.about }}</div>
                        </div>
                        <div class="pb-10 sm:px-0 px-5">
                            <div class=" text-gray-400 text-3xl pb-4 font-semibold">
                                Gallery
                            </div>
                            <div class="flex overflow-x-auto">
                                <v-avatar width="200" height="200"
                                    :class="`!border-2 ${routeLink}-border cursor-pointer !min-w-[200px]`"
                                    class="!mr-4 mb-4 !border-[2px] !border-gray-500 cursor-pointer group" rounded="lg"
                                    v-for="(item, idx)  in userData.user_images" :key="item.key">
                                    <div class="absolute top-0 left-0 z-20 w-full h-[85%]" @click="showMultiple(idx)"></div>
                                    <v-img :src="item.image" :lazy-src="item.image" aspect-ratio="1"
                                        gradient="to top, rgba(0,0,0,1), rgba(0,0,0,0)" class="grey lighten-2">
                                        <template v-slot:placeholder>
                                            <v-row class="fill-height ma-0" align="center" justify="center">
                                                <v-progress-circular indeterminate
                                                    color="grey lighten-5"></v-progress-circular>
                                            </v-row>
                                        </template>
                                        <template v-slot:default>
                                            <div class="grid w-full h-full grid-flow-col align-items-end ">
                                                <v-btn text dark :color="checkLiked(item) ? colorAsRoute : ''"
                                                    @click.prevent="likeSetter(item)"
                                                    class="!opacity-0 group-hover:!opacity-100">
                                                    <v-icon :color="checkLiked(item) ? colorAsRoute : ''"
                                                        small>mdi-thumb-up</v-icon><span v-if="item.likes_count > 0"
                                                        class="ml-2">{{ item.likes_count }}</span>
                                                </v-btn>
                                                <v-btn text dark :color="checkLoved(item) ? colorAsRoute : ''"
                                                    @click.prevent="loveSetter(item)"
                                                    class="!opacity-0 group-hover:!opacity-100">
                                                    <v-icon :color="checkLoved(item) ? colorAsRoute : ''"
                                                        small>mdi-heart</v-icon><span v-if="item.loves_count > 0"
                                                        class="ml-2">{{ item.loves_count }}</span>
                                                </v-btn>
                                            </div>
                                        </template>
                                    </v-img>

                                </v-avatar>
                            </div>
                            <div class=" bg-black !m-2 rounded-lg !animate-pulse !grid place-items-center  text-xl border-[1px] my-2 py-3  border-gray-500"
                                v-if="userData.user_images && !userData.user_images.length > 0">
                                Images Not Available
                            </div>
                        </div>
                        <div class="flex justify-end">
                            <v-btn :class="`${routeLink}_color !text-black !text-sm`" @click.prevent="Reqdialog = true"
                                right rounded>
                                Send Request
                            </v-btn>
                        </div>
                    </div>
                    <VueEasyLightbox moveDisabled :visible="visible" :imgs="images" :index="index" @hide="handleHide">
                    </VueEasyLightbox>
                </v-card>
            </v-dialog>
        </div>
    </div>
</template>

<script>

import { Icon } from '@iconify/vue2';
import axios from 'axios';
import VueEasyLightbox from 'vue-easy-lightbox'


export default {
    props: {
        userData: Object,
        dialog: Boolean
    },
    data() {
        return {
            // dialog: false,
            Reqdialog: false,
            standardLoad: false,
            images: [],
            visible: false,
            index: 0,  // defaults

        }
    },
    computed: {
        // dialogState(){
        //     return this.dialog
        // },
        loggedInUser() {
            return this.$store.getters.StateUser.data
        },
        colorAsRoute() {
            if (this.routeLink == "straight") {
                return "#a07a1d";
            }
            else if (this.routeLink == "gay") {
                return "#88c3fa";
            }
            else if (this.routeLink == "lesbian") {
                return "#9e2eec";
            }
        },
    },
    methods: {
        async likeSetter(image) {
            try {
                const resp = await axios.post('users/like/image', {
                    image_id: image.id,
                    user_id: this.userData.id
                })
                if (resp.status == 200) {
                    image.likes_count = resp.data.data.likes_count
                    image.liked_by = this.$store.getters.StateUser.data.id
                }
                console.log(resp)
            } catch (error) {
                console.log(error.response.data.message)
                await this.$store.dispatch("errorAction", error.response.data.message, {
                    root: true,
                })
            }
        },
        async loveSetter(image) {
            try {
                const resp = await axios.post('users/love/image', {
                    image_id: image.id,
                    user_id: this.userData.id
                })
                console.log(resp)
                if (resp.status == 200) {
                    image.loves_count = resp.data.data.loves_count;
                    image.loved_by = this.$store.getters.StateUser.data.id

                }
            } catch (error) {
                console.log(error.response.data.message)
                await this.$store.dispatch("errorAction", error.response.data.message, {
                    root: true,
                })
            }
        },
        checkLiked(item) {
            if (item.liked_by) {
                return true;
            } else {
                const userId = this.$store.getters.StateUser.data.id;
                return item.likes.find(e => e.liked_by == userId)
            }
        },
        checkLoved(item) {
            if (item.loved_by) {
                return true;
            } else {
                const userId = this.$store.getters.StateUser.data.id;
                return item.loves.find(e => e.loved_by == userId)
            }
        },
        async sendRequest(type) {
            try {
                this.Reqdialog = false;
                this.standardLoad = true;
                const resp = await axios.post(`send-user-request?to_uuid=${this.userData.uuid}`)
                //  console.log(resp.data.data)
                this.$toast(`${type} Date request sent to ${this.userData.name}. We'll let you know as soon as they respond. Good luck!`, {
                    position: "top-left",
                    timeout: 5000,
                    closeOnClick: true,
                    pauseOnFocusLoss: true,
                    pauseOnHover: true,
                    draggable: true,
                    draggablePercent: 0.6,
                    showCloseButtonOnHover: false,
                    hideProgressBar: false,
                    closeButton: "button",
                    icon: {
                        iconClass: "mdi mdi-checkbox-multiple-marked-outline",
                        iconChildren: "",
                        iconTag: "i"
                    },
                    rtl: false
                });
                this.notifyUser(type);
            } catch (error) {
                console.log(error)
            }
            finally {

                this.standardLoad = false;

            }

        },
        async notifyUser(type) {
            const receiver_name = this.userData.name;
            let messageData
            if (type == "Dutch") {
                messageData = `{"subject":"Invitation for a ${type} Date","message":" let's make it a ${type} date and split the bill! Want to grab a drink? Let's Connect! if you want to connect with ${this.$store.getters.StateUser.data.name}?", "user_data":"${this.$store.getters.getCometUUID}" ,"user_id":"${this.$store.getters.StateUser.data.id}", "sender_name":"${this.$store.getters.StateUser.data.name}", "user_image":"${this.$store.getters.StateUser.data.image}", "for_toast":"You have received a date request from ${this.$store.getters.StateUser.data.name}. Check your notifications to accept or decline the invitation."  }`
            } else {
                messageData = `{"subject":"Invitation for a ${type} Date","message":" I'd love to take you out on a proper date. How about we meet for meetup ?", "user_data":"${this.$store.getters.getCometUUID}" , "user_id":"${this.$store.getters.StateUser.data.id}", "for_toast":"You have received a date request from ${this.$store.getters.StateUser.data.name}. Check your notifications to accept or decline the invitation." ,"sender_name":"${this.$store.getters.StateUser.data.name}", "user_image":"${this.$store.getters.StateUser.data.image}" }`
            }
            const resp = await axios.post('store-notification', {
                uuid: this.$store.getters.getCometUUID,
                notifiable_id: this.userData.id,
                data: messageData
            })
        },
        showMultiple(idx) {
            this.images = this.loggedInUser.user_images.map((item) => item.image)
            this.index = idx  // index of imgList
            this.show()
        },
        show() {
            this.visible = true
        },
        handleHide() {
            this.visible = false
        },
    },
    components: { Icon, VueEasyLightbox }
}
</script>


<style scoped>
.straight-border {
    border-color: #a07a1d !important;
}

.gay-border {
    border-color: #88c3fa !important;
}

.lesbian-border {
    border-color: #9e2eec !important;
}

.straight_fortext {
    /* background: rgb(177, 145, 65); */
    background: linear-gradient(180deg,
            rgb(136 97 0) 0%,
            rgb(255 223 153) 53%,
            rgb(130 93 0 / 97%) 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}

.gay_fortext {
    /* background: rgb(177, 145, 65); */
    background: linear-gradient(357deg,
            rgba(0, 240, 255, 1) 55%,
            rgba(0, 156, 255, 1) 75%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}

.lesbian_fortext {
    /* background: rgb(177, 145, 65); */
    background: linear-gradient(208deg,
            rgba(126, 0, 157, 0.9416141456582633) 2%,
            rgba(161, 51, 246, 1) 45%,
            rgba(157, 0, 176, 0.9668242296918768) 96%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}

.for_icon:deep(.v-list-item__icon) {
    height: initial !important;
    margin: 16px 0 !important;
    margin-right: 32px !important;
}

.straight_color {
    /*background: linear-gradient(146deg, #dba83b, #d4b577 22%, #ae8935 30%, #a27c2b 70%, #d4b374 80%, #a87a2c);*/
    background: rgb(177, 145, 65);
    background: linear-gradient(180deg,
            rgb(97 69 0) 0%,
            rgba(202, 174, 112, 1) 53%,
            rgb(90 64 0 / 97%) 100%) !important;
}

.lesbian_color {
    background: rgb(126, 0, 157);
    background: linear-gradient(180deg,
            rgba(126, 0, 157, 0.9416141456582633) 2%,
            rgba(161, 51, 246, 1) 45%,
            rgba(157, 0, 176, 0.9668242296918768) 96%) !important;
}

.gay_color {
    background: rgb(0, 240, 255);
    background: linear-gradient(180deg,
            rgba(0, 240, 255, 1) 0%,
            rgba(0, 156, 255, 1) 100%) !important;
}

.spinner {
    animation: spin 0.5s linear infinite;
}

.straight-border {
    border-color: #a07a1d !important;
}

.gay-border {
    border-color: #88c3fa !important;
}

.lesbian-border {
    border-color: #9e2eec !important;
}


@-webkit-keyframes spin {
    from {
        transform: rotate(0deg)
    }

    to {
        transform: rotate(360deg)
    }
}

@keyframes spin {
    from {
        transform: rotate(0deg)
    }

    to {
        transform: rotate(360deg)
    }
}
</style>